
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import { mapGetters } from 'vuex'

export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    title: {
      default: '',
    },
    poster: {
      default: '',
    },
    videoLink: {
      default: () => ({
        token: '',
        link: '',
      }),
    },
  },
  data() {
    return {
      player: null,
      duration: 0,
      lazyTimeout: -1,
      clickCount: 0,
    }
  },
  computed: {
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
    }),
  },
  methods: {
    forward() {
      this.player.currentTime(this.player.currentTime() + 15)
    },
    backward() {
      this.player.currentTime(this.player.currentTime() - 15)
    },
    clickHandler() {
      if (this.player.paused()) {
        this.player.play()
      } else {
        this.player.pause()
      }
    },
  },
  mounted() {
    const vm = this


    console.log(this.videoLink,'videoLink',this.options,'options')

    if (this.getActiveUser.token)
      videojs.Vhs.xhr.beforeRequest = (option) => {
        // option.headers = {
        //   authorization: `Bearer ${this.getActiveUser.token}`,
        // }
        if (!option.uri.includes('part.m3u8') && !option.uri.includes('.mp4'))
          option.uri = option.uri + '?jwt_token=' + vm.videoLink.token
        return option
      }
    this.player = videojs(
      this.$refs.videoPlayer,
      {
        ...this.options,
        sources: this.videoLink.link ? [
          {
            src: this.videoLink.link,
            type: this.videoLink.link.includes('.mp4') ? 'video/mp4' : 'application/x-mpegURL',
          },
        ] : this.options.sources,
        userActions: {
          doubleClick: false,
        },
      },
      () => {
        var videoTitle = vm.player.controlBar.addChild('button', {}, 6)
        var videoTitleDom = videoTitle.el()
        videoTitleDom.innerHTML = this.title
        videoTitle.addClass('video-title')
        setTimeout(() => {
          this.$emit('video:init', vm.player)
        }, 150)

        // Çift tıklama ve dokunmatik olayları dinle
        let lastTap = 0;
        const tapThreshold = 300; // 300ms içinde iki kez dokunma

        this.player.el().addEventListener('dblclick', function (e) {
          handleSeek(e.clientX);
        });

        this.player.el().addEventListener('touchstart', function (e) {
          const currentTime = new Date().getTime();
          const tapLength = currentTime - lastTap;
          
          if (tapLength < tapThreshold && tapLength > 0) {
            // Çift dokunma algılandı
            const touch = e.touches[0];
            handleSeek(touch.clientX);
            e.preventDefault();
          }
          
          lastTap = currentTime;
        });

        const handleSeek = (clientX) => {
          const bounds = this.player.el().getBoundingClientRect();
          const x = clientX - bounds.left;
          const width = bounds.width;
          const currentTime = this.player.currentTime();
          const seekAmount = 10;

          if (x < width / 2) {
            this.player.currentTime(Math.max(0, currentTime - seekAmount));
          } else {
            this.player.currentTime(Math.min(this.player.duration(), currentTime + seekAmount));
          }
        };

        this.player.on('loadedmetadata', function (e) {
          vm.$emit('video:loadedmetadata', vm.player)
        })
        this.player.on('error', function (e) {
          vm.$emit('error', vm.player)
        })
        this.player.on('play', function (e) {
          vm.$emit('video:play', vm.player)
        })
        this.player.on('playing', function (e) {
          vm.$emit('video:playing', vm.player)
        })

        this.player.on('pause', function (e) {
          vm.$emit('video:pause', vm.player)
        })

        this.player.on('seeking', function (e) {
          vm.$emit('video:seeking', vm.player)
        })

        this.player.on('seeked', function (e) {
          vm.$emit('video:seeked', vm.player)
        })
        this.player.on('timeupdate', function (e) {
          const d = Math.ceil(vm.player.currentTime())
          if (d !== vm.duration) {
            vm.$emit('video:playing', vm.player)
            vm.duration = d
          }
        })

        this.player.on('ended', function (e) {
          vm.$emit('video:ended', vm.player)
        })
      }
    )
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
}
